import { useParams } from 'react-router-dom';
import { NotFound } from '@pages/not-found/index';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import type { ExerciseVideo } from '@shared/types/exercises';
import { PlayerInCard } from '@shared/ui/iframes/PlayerInCard/ui';
import { ListBody, PageHead } from '@shared/ui/index';
import { useCoachVideoQuery } from '@src/api/api-hooks/coaches/useCoachVideoQuery.ts';
import { Loader } from '@src/library/components/common/index';

export const CoachVideoPage = () => {
  const { coachVideoId } = useParams();

  const { data: coachVideo, isLoading: isCoachVideoFetching } = useCoachVideoQuery({
    id: coachVideoId,
  });
  if (isCoachVideoFetching) {
    return <Loader />;
  }
  console.log("coachVideo: ", coachVideo);
  return coachVideo ? (
    <>
      {/*<Header MCenter={<>Видео</>} menuClassName={shared.hide} />*/}

      <PageHead Left={<PageBackButton />} Center={'Видео'} />

      <ListBody>
        <PlayerInCard
          video={
            {
              video_type: 'B',
              ...coachVideo,
            } as unknown as ExerciseVideo
          }
        />
      </ListBody>
    </>
  ) : (
    <NotFound />
  );
};
